import PageLayout from "@/app/(hydrogen)/file-manager/page-layout";
import FileUpload from "@/app/shared/file-upload";
import FileStats from "@/app/shared/file/manager/file-stats";
import PageHeader from "@/app/shared/page-header";
import UploadButton from "@/app/shared/upload-button";
import { metaObject } from "@/config/site.config";
import routes from "@/routers/routes";

export const metadata = {
    ...metaObject("File Manager"),
};

const pageHeader = {
    title: "File Manager",
    breadcrumb: [
        {
            href: routes.eCommerce.dashboard,
            name: "Home",
        },
        {
            href: routes.file.dashboard,
            name: "File Manager",
        },
        {
            name: "List",
        },
    ],
};

export default function FileListPage() {
    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            >
                <UploadButton modalView={<FileUpload />} />
            </PageHeader>

            <FileStats className="mb-6 @5xl:mb-8 @7xl:mb-11" />
            <PageLayout />
        </>
    );
}
